// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/skeleton/style/index.less
// module id = 1138
// module chunks = 1